import { PageViewEventLogger } from '@repo/tracking-service';

import { PersonalDeductionContainer } from '@/components/survey/personal-deduction/PersonalDeductionContainer';

function PersonalDeductionPage() {
  return (
    <PageViewEventLogger pageName={'personal-deduction-intro'}>
      <PersonalDeductionContainer />
    </PageViewEventLogger>
  );
}

export default PersonalDeductionPage;
